import React, { useState } from 'react';
import BusinessHeader from '../components/atoms/BusinessHeader';
import AllStoresSection from '../components/atoms/AllStoresSection';
import CenterModal from '../components/molecules/Modal/CenterModal';
import AddStoreModal from '../components/atoms/AddStoreModal';
import AddDeviceModal from '../components/atoms/AddDeviceModal';
import SuccessModal from '../components/atoms/SuccessModal';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../Context/authContext';
import { useContextHook } from 'use-context-hook';
import storeService from '../services/storeService';

const BusinessStore = () => {
  const param = useParams();
  const { id } = param;
  const [searchQuery, setSearchQuery] = useState({
    page: 1,
    pageSize: 10,
    searchText: '',
    businessId: id,
    filterStatus: '',
  });
  const [addStoreModal, setAddStoreModal] = useState(false);
  const [addDeviceModal, setAddDeviceModal] = useState(false);
  const [storeSuccessModal, setStoreSuccessModal] = useState(false);
  const [deviceSuccessModal, setDeviceSuccessModal] = useState(false);
  const [submission, setSubmission] = useState(false);
  const { refetch, fetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
    fetch: v.fetch,
  }));
  const { stores_data, stores_loading } = storeService.GetStores(searchQuery, fetch);
  const CreateStoreModal = () => {
    setAddStoreModal(true);
  };

  const handleStoreSuccessModal = () => {
    if (submission === true) {
      setAddStoreModal(false);
      setAddDeviceModal(true);
      setSubmission(false);
    } else {
      setAddStoreModal(false);
      setStoreSuccessModal(true);
    }
  };

  const handleDeviceSuccessModal = () => {
    setAddDeviceModal(false);
    setDeviceSuccessModal(true);
  };
  return (
    <>
      {/* ------------------  Modal  ---------------- */}
      <CenterModal open={addStoreModal} setOpen={setAddStoreModal} title="Add New Store" width="700">
        <AddStoreModal
          onSubmit={handleStoreSuccessModal}
          setSubmission={() => setSubmission(true)}
          data={stores_data?.businessData?.businessData}
          refetch={refetch}
        />
      </CenterModal>
      <CenterModal open={addDeviceModal} setOpen={setAddDeviceModal} title="Add New Device" width="666">
        <AddDeviceModal onSubmit={handleDeviceSuccessModal} />
      </CenterModal>
      <CenterModal open={storeSuccessModal} setOpen={setStoreSuccessModal} width="666">
        <SuccessModal
          heading="Store Created Successfully!"
          para="Your store creation is successfully completed, now you can create multiple devices in it."
        />
      </CenterModal>
      <CenterModal open={deviceSuccessModal} setOpen={setDeviceSuccessModal} width="580">
        <SuccessModal heading="Device Created Successfully!" para="Your device creation is successfully completed." />
      </CenterModal>
      {/* ------------------  Modal  ---------------- */}

      <BusinessHeader
        heading="Stores!"
        placeholder="Search Stores..."
        searchQuery={searchQuery?.searchText}
        setSearchQuery={setSearchQuery}
      />
      <AllStoresSection
        CreateStoreModal={CreateStoreModal}
        data={stores_data}
        refetch={refetch}
        currentPage={searchQuery.page}
        pageSize={searchQuery.pageSize}
        totalCount={stores_data?.totalItems}
        stores_loading={stores_loading}
        onChangeFilters={filters => {
          setSearchQuery(_ => ({
            ..._,
            ...filters,
          }));
        }}
      />
    </>
  );
};

export default BusinessStore;
